import React from "react";
import { Switch } from "react-router-dom";
import Clientes from "./components/Pages/Clientes/Clientes";
import Societies from "./components/Pages/Societies/Societies";
import Compliances from "./components/Pages/Compliances/Compliances.js";
import Usuarios from "./components/Pages/Usuarios/Usuarios";
import UsuariosAD from "./components/Pages/UsuariosAD/UsuariosAD";
import Perfil from "./components/Pages/Perfil/Perfil";
import PrivateRoute from "./components/PrivateRoute";
import Retainer from "./components/Pages/Retainer/Retainer";
import Auditoria from "./components/Pages/Auditoria/Auditoria";
import LawyerInformation from "./components/Pages/LawyerInformation/LawyerInformation";
import Workspaces from "./components/Pages/Workspaces/Workspaces";
import Administracion from "./components/Pages/Administracion/Administracion";
import { MisDocumentosIndex } from "./components/Pages/MisDocumentos/MisDocumentosIndex";
import { SociedadDetalle } from "./components/Pages/SociedadDetalle/SociedadDetalle";
import AdministracionSociety from "./components/Pages/Administracion/AdministracionSociety";
import NotificationCenter from "./components/Pages/NotificationCenter/NotificationCenter.js";
import CalendarioCustom from "./components/Pages/Calendario/CalendarioCustom.js";
import { ClienteDetalleIndex } from "./components/Pages/ClienteDetalle/ClienteDetalleIndex.js";

const Routes = () => {
  return (
    <div>
      <Switch>
        <PrivateRoute
          exact
          path="/MisDocumentos"
          component={MisDocumentosIndex}
        />
        <PrivateRoute
          exact
          path="/client/:client_id"
          component={ClienteDetalleIndex}
        />
        <PrivateRoute
          exact
          path="/society/:society_id"
          component={SociedadDetalle}
        />
        <PrivateRoute exact path="/Retainer" component={Retainer} />
        <PrivateRoute exact path="/Workspaces" component={Workspaces} />
        <PrivateRoute exact path="/Administracion" component={Administracion} />
        <PrivateRoute exact path="/AdministracionSociety" component={AdministracionSociety} />
        <PrivateRoute exact path="/Clientes" component={Clientes} />
        <PrivateRoute exact path="/Societies" component={Societies} />
        <PrivateRoute exact path="/Compliance" component={Compliances} />
        <PrivateRoute exact path="/Condominios" component={Clientes} />
        <PrivateRoute exact path="/Usuarios" component={Usuarios} />
        <PrivateRoute exact path="/UsuariosAD" component={UsuariosAD} />
        <PrivateRoute exact path="/Perfil" component={Perfil} />
        <PrivateRoute exact path="/NotificationCenter" component={NotificationCenter} />
        <PrivateRoute exact path="/Calendario" component={CalendarioCustom} />
        <PrivateRoute exact path="/Historial" component={Auditoria} />
        <PrivateRoute exact path="/Lawyer" component={LawyerInformation} />
        <PrivateRoute
          exact
          path="/PredictYourDates"
          component={CalendarioCustom}
        />
      </Switch>
    </div>
  );
};

export default Routes;
